import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme, ButtonBase } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import InboundsCard from "../../../../components/global/cards/inbounds/InboundsCard";
import MpAddInbound from "../../../../components/global/ModalsProgression/MpAddInbound/MpAddInbound";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import ShLabel from "../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { useExportInboundsMutation, useGetInboundsQuery } from "../../../../newapi/inbound/inboundsSlice";
import { tokens } from "../../../../theme";

import { useSelector } from "react-redux";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import ShCopyButton from '../../../../components/theme/ShCopy';
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader';
import { getInboundStateData } from '../../../../utils/labelColorText';
import LabelNotice from '../../../../components/theme/label/LabelNotice';
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../utils/permissions";
import { INBOUND_FILTER_KEYS } from '../../../../components/global/DataGrid/Filter';
import { DownloadOutlined } from "@mui/icons-material";
import { showToastPromise } from '../../../../utils/toasts';
import MImportData from '../../../../components/global/Modals/MImportData';
import { ImportStandAloneFileLogo } from "../../../../utils/importColumnDefinitions";
import { ENV_TYPES } from '../../../../components/global/Sidebar';
import { useGetRelationForMenuQuery } from '../../../../newapi/global/relation/relationSlice';
import { inboundRelationColums } from '../../../../components/theme/import/ImportColumnHelper';
import { selectEnvironmentid } from "../../../../newapi/global/settingsSlice";
import  UploadOutlinedIcon  from '@mui/icons-material/UploadOutlined';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import ShDataGrid3 from '../../../../components/theme/datagrid3/ShDataGrid3';

const SpInboundDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpInboundDetails/SpInboundDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonGroup version={2}>
            {props.importAllowed && (
             <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "grey" : "grey"} 
                onClick={() => {
                    props.importOrdersOpen();
                }}
                endIcon={<UploadOutlinedIcon/>}
                variant="contained"
            >
                {t('import')}
            </Shbutton>
            )}
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={() => props.exportInbounds()}
                endIcon={<DownloadOutlined/>}
                variant="contained"
                isLoading={props.isExporting}
            >
                {t("export")}
            </Shbutton>
            {props.hasCreatePermission && (
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_inbound')}
            </Shbutton>
            )}
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [INBOUND_FILTER_KEYS.STATE, INBOUND_FILTER_KEYS.PRODUCT, INBOUND_FILTER_KEYS.SUPPLIER],
};

const InboundInbounds = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [config, setConfig] = useState({"relationId": useSelector((state) => state.settings.environment.selectedId)});
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_INBOUND_MANAGE])
    );

    const selectedEnvironmentId = useSelector(selectEnvironmentid);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    
    const {data:relationMenuData,isFetching:isFetching2,isLoading:isLoading2} = useGetRelationForMenuQuery(selectedEnvironmentId, {
        skip: selectedEnvironmentType !== ENV_TYPES[200]
    });

    const [importAllowed, setImportAllowed] = useState(null);

    useEffect(() => {
        if (relationMenuData) {
            const importOrderSetting = relationMenuData.settings?.find(x => x.key === "relation_import_order");
            if (importOrderSetting && importOrderSetting.value === "true") {
                setImportAllowed(true);
            }
        }
    }, [relationMenuData])

    const [importOrdersModalOpen,setImportOrdersModalOpen] = useState(false);
    const importOrdersModal = {
        open: importOrdersModalOpen,
        setOpen: setImportOrdersModalOpen,
    }

    const importOrdersOpen = () => {
        setImportOrdersModalOpen(true);
    }

    const importOrdersClose = () => {
        setImportOrdersModalOpen(false);
    }
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions importOrdersOpen={importOrdersOpen} importAllowed={importAllowed} hasCreatePermission={hasCreatePermission} handleOpen={() => setAddModalOpen(true)}
             isExporting={isExporting} exportInbounds={exportInboundsCall}></GridActions>,
        });

        return () => {
            
        }
    },[]);

    // The totals panel lives above the tab view, in the parent, and belongs to this tab only.
    // Report that this tab is open so it shows, and that it closed so it goes away again.
    useEffect(() => {
        props.onActiveChange?.(true);

        return () => props.onActiveChange?.(false);
    },[]);

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };
    
    const [exportInbounds, {isLoading: isExporting}] = useExportInboundsMutation();
    const exportInboundsCall = async () => {  
        const exportPromise = exportInbounds().unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            if (result.processing) {
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }

    const [inboundIsExtended, setInboundIsExtended] = useState(false);
    const [inboundId, setInboundId] = useState();
    const inboundIdRef = useRef(inboundId);
    
    const getInboundDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (inboundIdRef.current !== newProductId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setInboundId(newProductId);
            inboundIdRef.current = newProductId; // Update the ref to the new value
        }
        setInboundIsExtended(true);
    };

    const columns = [
        {field: "barcode", headerName: t("purchase_order"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return(
                    <Text>
                        {params.row.barcode}
                    </Text>
                )
            }
        },
        {
            field: "reference", 
            headerName: t("reference"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.reference}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.reference}
                        ></ShCopyButton>
                    </Box>
                )
            }
        },
        {
            field: "shipmentDate",
            headerName: t("shipment_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.shipmentDate);

                // Check if date is 01-01-1970 (Unix epoch)
                if (date.getTime() === 0 || date.toISOString().startsWith('1970-01-01')) {
                    return <Text>{t('no_date')}</Text>;
                }

                return (
                    <Text>
                        {date.toLocaleDateString(i18n.language)}
                    </Text>
                );
            }
        },
        {field: "skuCount", headerName: t("sku_count"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.skuCount;
            }
        },
        {field: "itemCount", headerName: t("items"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.itemCount;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext, extraLabel } = getInboundStateData(params.row.state, theme, params.row.incompleteReceived);
              
                return (
                    <Box sx={{display:"flex", alignItems:"center", gap:1}}>
                        <ShLabel size={32} palette="normal" variant={labelcolor}>
                          {t(labeltext)}
                        </ShLabel>
                        {extraLabel && <LabelNotice text={t(extraLabel.labeltext)}/>}
                    </Box>
                  );
              }
        },
        {
            field: "receivedFromDate", 
            headerName: t("received_date"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if(params.row.receivedFromDate === null ) {
                    return <Text>-</Text>
                }

                let from = new Date(params.row.receivedFromDate);
                let dateFrom = from.toLocaleDateString(i18n.language);
                let dateTo = ""
                if (params.row.receivedToDate) {
                    let to = new Date(params.row.receivedToDate);
                    dateTo = to.toLocaleDateString(i18n.language);
                }

                const dateString = dateTo.length > 0 && dateTo !== dateFrom ? `${dateFrom} / ${dateTo}` : dateFrom;

                return (
                    <Text>
                        {dateString}
                    </Text>
                );
            }
        },
        {field: "supplier", headerName: t("supplier"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.supplier?.name;
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <InboundsCard onClick={() => getInboundDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row} />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3 
                key={theme.palette.mode}
                gridKey="relations.inbounds"
                content={useGetInboundsQuery}
                config={config}
                gridActions={
                    <GridActions
                        importOrdersOpen={importOrdersOpen}
                        importAllowed={importAllowed}
                        hasCreatePermission={hasCreatePermission}
                        handleOpen={() => setAddModalOpen(true)}
                        isExporting={isExporting}
                        exportInbounds={exportInboundsCall} >
                    </GridActions>
                }
                title={t('all_inbounds') }
                gridOptions={gridOptions} 
                sortModel={{field: columns[2].field,type:"DESC"}}
                columns={columns}
                onRowClick={getInboundDetails}>
            </ShDataGrid3>

            {spLoading && 
                <SpInboundDetails
                    isExtended={inboundIsExtended}
                    setIsExtended={setInboundIsExtended}
                    inboundId={inboundId}
                /> 
            }
            <MImportData
                onOpen={() => importOrdersModal.setOpen(true)} 
                onClose={() => importOrdersModal.setOpen(false)} 
                open={importOrdersModal.open} 
                handleClose={importOrdersClose} 

                logo={<ImportStandAloneFileLogo Icon={CallMadeOutlinedIcon} />}
                title={t("import_inbound")}
                fileType={"inkoop"}
                columns={inboundRelationColums}
                exampleFile={"/Voorbeeld_import_klant.xlsx"}
            />
            
            <MpAddInbound onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} onOpenCreatedInbound={(id) => getInboundDetails({ row: { id } })} />
        </Box>
    );
}

export default InboundInbounds;